export default __webpack_public_path__ + "static/media/ProgressiveLabsHealthPlanBrandingLogo.eacdfe7d.png";